import { ExternalLinkButton } from "../../../../src/components/components";
import GalleryDinnerSection from "../../../../src/components/sections/gallery-dinner-section";
import * as React from 'react';
export default {
  ExternalLinkButton,
  GalleryDinnerSection,
  React
};